import { formatCurrency } from './utils';

document.addEventListener("DOMContentLoaded", async () => {

  const shopCurrency = window.Shopify.currency.active;
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: shopCurrency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  const displayedPrice = document.querySelector('#displayedPrice');
  const compareAtPrice = document.querySelector('#compareAtPrice');
  const variantSelects = document.querySelectorAll('.variant-select');
  const sellingPlanFields = document.querySelectorAll(`input[name="selling_plan"]`);
  const displayedSku = document.querySelector('#displayedSku');
  const cartQtyIndicator = document.getElementById('cartQtyIndicator');

  const isVaultMember = document.getElementById('isVaultMember').value;

  // there are two versions of this select now, for small and large screens
  // on change, we need to update the displayed price and selling plan id (if one exists)
  variantSelects.forEach((select) => {
    
    select.addEventListener('change', (e) => {

      let selectedOption = select.selectedOptions[0];
      let selectedVariantPrice = selectedOption.dataset.price;      
      displayedPrice.innerHTML = formatter.format(selectedVariantPrice / 100);

      let selectedCompareAt = selectedOption.dataset.compareAt;
      if (selectedCompareAt) {
        compareAtPrice.innerHTML = '<s>'+formatter.format(selectedCompareAt / 100)+'</s>';
        compareAtPrice.classList.remove('d-none');
      } else {
        compareAtPrice.classList.add('d-none');
      }
      
      let selectedVariantDetails = JSON.parse(selectedOption.dataset.detailsJson);
      
      let selectedVariantSku = selectedVariantDetails.sku;
      // some PDPs do not display a sku (e.g. Vault)
      if (displayedSku) {
        displayedSku.innerHTML = selectedVariantSku;
      }

      // set order limit, if there is one. this comes from the variant metafield order_limit value (or the legacy tag, which can only be set at the product level)
      let selectedVariantOrderLimit = selectedOption.dataset?.orderLimit;
      let qtyInput = thisForm.querySelector(`[name="quantity"]`);
      // some PDPs may not have a qty input (e.g. Vault)
      if (qtyInput) {
        qtyInput.max = selectedVariantOrderLimit;
      }

      let lowStockAlert = document.getElementById('lowStockAlert');
      let lowStockQty = document.getElementById('lowStockQty');
      let selectedVariantQty = Number(selectedOption.dataset.inventoryQty);
      let lowStockThreshold = Number(document.getElementById('lowStockThreshold').value);
      if (selectedVariantQty > 0 && selectedVariantQty <= lowStockThreshold) {
        console.log('low stock condition met!');
        lowStockAlert.classList.remove('d-none');
        lowStockQty.innerHTML = selectedVariantQty;
      } else {
        lowStockAlert.classList.add('d-none');
      }

      if (selectedOption.dataset.sellingPlan) {
        const sellingPlanId = selectedOption.dataset.sellingPlan;
        sellingPlanFields.forEach((field) => {
          field.value = sellingPlanId;
        })
      }

    });

  });

  const ajaxCartModal = new bootstrap.Modal('#ajaxCartModal');
  const productForms = document.querySelectorAll('.shopify-product-form');
  
  productForms.forEach((form) => {
      form.addEventListener('submit', async (e) => {
      
        e.preventDefault();

        let variantID = e.target.querySelector('[name="id"]').value;
        let qty = e.target.querySelector('input[name="quantity"]')?.value ?? 1;
        let sellingPlanID = e.target.querySelector('input[name="selling_plan"]')?.value;
        let propertiesInputs = Array.from(e.target.querySelectorAll('[name*="properties"]'));
        let atcButton = e.target.querySelector('[type="submit"]');
        
        let properties = {};
        propertiesInputs?.forEach((input) => {
          let propKey = input.name.match(/\[(.*?)\]/)[1];
          properties[propKey] = input.value;
        });
                
        let data = {
          'items': [{
            "id": variantID,
            "quantity": qty,
            "selling_plan": sellingPlanID,
            "properties": properties
          }]
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
        .then(() => {
          return fetch(window.Shopify.routes.root + 'cart.js', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })
        })
        .then(response => response.json())
        .then(data => {

          validateCart(data, atcButton);
          cartQtyIndicator.innerHTML = data?.item_count;
          cartQtyIndicator.classList.remove('d-none');
          populateAjaxCartModal(data, shopCurrency);
          ajaxCartModal.show();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    });
  });
  
});

async function populateAjaxCartModal(data) {
  const ajaxCartModalBody = document.getElementById('ajaxCartModalBody');  
  const shopCurrency = data.currency;
  const items = data.items;
  
  let cartRows = '';
  let personalizedMessage;
  let personalizedMessageRow;

  items.forEach(item => {
    console.log('item', item);
    item.properties['Personalized message'] ? personalizedMessage = item.properties['Personalized message'] : personalizedMessage = '';

      if (personalizedMessage !== '') {
        personalizedMessageRow = `
        <span>Personalized message: ${personalizedMessage}</span><br>
        `
      }

      /* let propertyRows = '';
        only want to show the ones that don't start with underscore!
        and maybe some other constraints... not doing these at all for now
      for (const prop in item.properties) {
        propertyRows += `
        <span>${prop}: ${item.properties[prop]}</span><br>
        `;
      }*/

      cartRows += `
      <div class="row mb-4 text-white fw-bold">
        <div class="col-3 col-lg-3">
          <a href="${item.url}"><img src="${item.image}&width=100" class="w-100"></a>
        </div>
        <div class="col-9 col-lg-9">
          <div class="row">
            <div class="col text-start small fw-normal">${item.properties['_artist'] ?? ''}</div>
          </div>
          <div class="row">
            <div class="col text-start small">
              <a href="${item.url}" class="text-tmr-yellow text-decoration-none">${item.product_title}</a>
            </div>
          </div>
          <div class="row">
            <div class="col text-secondary-dark-bg tiny">
              ${item?.variant_title ?? ''}<br>
              ${personalizedMessageRow ?? ''}
            </div>
            <div class="col text-end text-lowercase small"><span class="tiny">${item.quantity} x</span> ${formatCurrency(item.price, shopCurrency)}</div>
          </div>
        </div>
      </div>
      `;
  });

  ajaxCartModalBody.innerHTML = cartRows;
  
}

// prevent multiple Vault subs from being added to cart
// passing atcButton so it can be disabled
async function validateCart(data, atcButton) {
  
  const cartItems = data.items;
  let hasSubscriptionLineItem = cartItems.some((item) => {
    let props = item.properties;
    return Object.hasOwn(props, '_subscription_line_item');
  });
  
  if (hasSubscriptionLineItem) {
    console.log('validateCart: hasSubscriptionLineItem', hasSubscriptionLineItem);
    atcButton.disabled = true;
  }

}

if (!customElements.get('recipient-form')) {
  customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
      constructor() {
        super();
        this.recipientFieldsLiveRegion = this.querySelector(`#Recipient-fields-live-region-${this.dataset.sectionId}`);
        this.recipientFields = this.querySelector(`.recipient-fields`);
        this.checkboxInput = this.querySelector(`#Recipient-checkbox-${this.dataset.sectionId}`);
        this.checkboxInput.disabled = false;
        this.hiddenControlField = this.querySelector(`#Recipient-control-${this.dataset.sectionId}`);
        this.hiddenControlField.disabled = true;
        this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
        this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
        this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
        this.sendonInput = this.querySelector(`#Recipient-send-on-${this.dataset.sectionId}`);
        this.offsetProperty = this.querySelector(`#Recipient-timezone-offset-${this.dataset.sectionId}`);
        if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();

        this.errorMessageWrapper = this.querySelector('#error-message-wrapper');
        this.errorMessageList = this.errorMessageWrapper?.querySelector('ul');
        this.errorMessage = this.errorMessageWrapper?.querySelector('.error-message');
        this.defaultErrorHeader = this.errorMessage?.innerText;
        this.currentProductVariantId = this.dataset.productVariantId;
        this.addEventListener('change', this.onChange.bind(this));
        this.onChange();
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;
      cartErrorUnsubscriber = undefined;

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
            this.resetRecipientForm();
          }
        });

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId === this.dataset.sectionId) {
            this.currentProductVariantId = event.data.variant.id.toString();
          }
        });

        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
          if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
            this.displayErrorMessage(event.message, event.errors);
          }
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }

        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }

        if (this.cartErrorUnsubscriber) {
          this.cartErrorUnsubscriber();
        }
      }

      onChange() {
        if (this.checkboxInput.checked) {
          console.log('recipient-form.js: checkbox checked');
          this.recipientFields.style.display = 'block';
          this.enableInputFields();
          //this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormExpanded;
        } else {
          this.recipientFields.style.display = 'none';
          this.clearInputFields();
          this.disableInputFields();
          this.clearErrorMessage();
          //this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormCollapsed;
        }
      }

      inputFields() {
        return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput];
      }

      disableableFields() {
        return [...this.inputFields(), this.offsetProperty];
      }

      clearInputFields() {
        this.inputFields().forEach((field) => (field.value = ''));
      }

      enableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = false));
      }

      disableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = true));
      }

      displayErrorMessage(title, body) {
        this.clearErrorMessage();
        this.errorMessageWrapper.hidden = false;
        if (typeof body === 'object') {
          this.errorMessage.innerText = this.defaultErrorHeader;
          return Object.entries(body).forEach(([key, value]) => {
            const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
            const fieldSelector = `#Recipient-${key}-${this.dataset.sectionId}`;
            const message = `${value.join(', ')}`;
            const errorMessageElement = this.querySelector(`#${errorMessageId}`);
            const errorTextElement = errorMessageElement?.querySelector('.error-message');
            if (!errorTextElement) return;

            if (this.errorMessageList) {
              this.errorMessageList.appendChild(this.createErrorListItem(fieldSelector, message));
            }

            errorTextElement.innerText = `${message}.`;
            errorMessageElement.classList.remove('hidden');

            const inputElement = this[`${key}Input`];
            if (!inputElement) return;

            inputElement.setAttribute('aria-invalid', true);
            inputElement.setAttribute('aria-describedby', errorMessageId);
          });
        }

        this.errorMessage.innerText = body;
      }

      createErrorListItem(target, message) {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.setAttribute('href', target);
        a.innerText = message;
        li.appendChild(a);
        li.className = 'error-message';
        return li;
      }

      clearErrorMessage() {
        this.errorMessageWrapper.hidden = true;

        if (this.errorMessageList) this.errorMessageList.innerHTML = '';

        this.querySelectorAll('.recipient-fields .form__message').forEach((field) => {
          field.classList.add('hidden');
          const textField = field.querySelector('.error-message');
          if (textField) textField.innerText = '';
        });

        [this.emailInput, this.messageInput, this.nameInput, this.sendonInput].forEach((inputElement) => {
          inputElement.setAttribute('aria-invalid', false);
          inputElement.removeAttribute('aria-describedby');
        });
      }

      resetRecipientForm() {
        if (this.checkboxInput.checked) {
          this.checkboxInput.checked = false;
          this.clearInputFields();
          this.clearErrorMessage();
        }
      }
    }
  );
}
